import React from "react";
import { useParams } from "react-router-dom";
import { Box, Spinner, Text } from "@chakra-ui/react";
import { useGetProductsQuery } from "../../productApi/productAPI";
import ProductDetails from "./ProductDetails";
import GlobalSpinner from "../CustomReusables/GlobalSpinner";

const ProductDetailsPage = () => {
  const { id } = useParams();
  const { data: products = [], isLoading } = useGetProductsQuery();

  const product = products.find((p) => p._id === id);

  if (isLoading) return <GlobalSpinner />;

  if (!product) {
    return (
      <Box p={8}>
        <Text fontSize="xl" color="red.500">
          Product not found
        </Text>
      </Box>
    );
  }

  return (
    <Box>
      <ProductDetails product={product} />
    </Box>
  );
};

export default ProductDetailsPage;
